<template>
  <a-drawer
    :visible="visible"
    title="材料项管理"
    width="60%"
    :destroy-on-close="false"
    :mask-closable="false"
    @close="close"
  >
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="材料项名称">
                <a-input v-model="queryParam.materialItemName" placeholder="请输入" allow-clear @keyup.enter="handleQuery" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select
                  show-search
                  v-model="queryParam.status"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  style="width: 100%"
                  allow-clear
                >
                  <a-select-option :value="0">禁用</a-select-option>
                  <a-select-option :value="1">启用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"> <a-icon type="search" />查询 </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"> <a-icon type="redo" />重置 </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <template v-if="isOperate">
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd(prodSkuId)"
            v-hasPermi="['upkeep:prod-sku-material-item:add']"
          >
            <a-icon type="plus" />新增
          </a-button>
          <a-button
            type="danger"
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['upkeep:prod-sku-material-item:remove']"
          >
            <a-icon type="delete" />删除
          </a-button>

        </template>

        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <create-form
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
      />

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <template>
            <a-tag v-if="record.status == 0" color="#f50">禁用</a-tag>
            <a-tag v-else-if="record.status == 1" color="#87d068">启用</a-tag>
          </template>
        </span>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <span slot="pricingType" slot-scope="text, record">
          {{ record.pricingType ? '自定义' : '固定' }}
        </span>

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['upkeep:prod-sku-material-item:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['upkeep:prod-sku-material-item:remove']"> 删除 </a>
        </span>
      </a-table>

      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-drawer>
</template>

<script>
import { fetchList, delObj, statusObj } from '@/api/repairModule/productMaterials'
import CreateForm from './MatCreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'

export default {
  name: 'MaterialItemDrawer',
  components: { CreateForm },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      advanced: false,
      multiple: true,
      visible: false,
      list: [],
      prodSkuId: '',
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        status: undefined,
        tenantFirmId: undefined,
        tenantId: undefined,
      },
      columns: [
        {
          title: '材料项名称',
          dataIndex: 'materialItemName',
          align: 'center',
        },
        {
          title: '服务价格',
          dataIndex: 'price',
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '定价类型',
          dataIndex: 'pricingType',
          scopedSlots: { customRender: 'pricingType' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  methods: {

    open(record) {
      this.visible = true
      this.queryParam.prodSkuId = record.id
      this.prodSkuId = record.id
      this.getList()
      if (!this.userList.length) {
        this.getQi()
      }
    },
    close() {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
      this.ids = []
    },
    getQi() {
      listTenant({ pageNum: 1, pageSize: 999, type: 1, status: 0 }).then((res) => {
        this.userList = res.data.records
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleStatusType(row) {
      statusObj({ id: row.id })
        .then(() => {
          this.$message.success('操作成功！')
          this.getList()
        })
        .catch(function () {
          row.status = row.status == '0' ? '1' : '0'
        })
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
       this.queryParam = Object.assign({}, this.queryParam, {
        pageNum: 1,
        pageSize: 10,
        status: undefined,
      })
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.multiple = !selectedRowKeys.length
    },
    handleDelete(row) {
      var that = this
      let ids = []

      if (row && row.materialItemId) {
        ids = [{
          materialItemId: row.materialItemId,
          prodSkuId: that.prodSkuId,
        }]
      } else {
        if (this.selectedRows.length === 0) {
          this.$message.warning('请先选择要删除的数据')
          return
        }
        ids = this.selectedRows.map(item => ({
          materialItemId: item.materialItemId || item.id,
          prodSkuId: that.prodSkuId,
        }))
      }

      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.selectedRowKeys = []
            that.selectedRows = []
            that.multiple = true
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
  },
}
</script>
